import { graphHooks } from '@tunasong/graph-lib/react'
import manifest from '@tunasong/manifest'
import { hasSystemTag, SystemTags } from '@tunasong/models'
import type { Entity, Persisted } from '@tunasong/schemas'
import { Typography, UploadStoredEntity } from '@tunasong/ui-lib'
import type { FC } from 'react'
import invariant from 'tiny-invariant'
import BookmarksButton from './bookmarks.js'
import styles from './controls.module.css'

export interface FolderControlsProps {
  entity?: Persisted<Entity>
  onActive?(active: boolean): void
}

export const FolderControls: FC<FolderControlsProps> = props => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { entity: folder, onActive } = props

  const [createEdge] = graphHooks.useEntityEdgeCreate()
  const handleUploaded = async (entity: Persisted<Entity>) => {
    // Create the edge
    invariant(folder, 'Folder must be defined')
    await createEdge({
      edge: {
        source: folder.id,
        target: entity.id,
        relation: 'hasImage',
      },
    })
  }

  /** @todo replace with e.g., useEdgeEntity({sourceId: folder.id, relation: 'hasImage'}) */
  const { child: existingHeaderImage } = graphHooks.useEntityChild({
    parentId: folder?.id,
    filter: hasSystemTag(SystemTags.HeaderImage),
  })
  const [deleteEntity] = graphHooks.useEntityDelete()

  const handleUploading = () => {
    if (!existingHeaderImage) {
      return
    }
    void deleteEntity({ entity: existingHeaderImage })
  }
  if (!folder) {
    return null
  }

  return (
    <>
      <Typography variant="subtitle1" className={styles.sectionTitle}>
        Header Image
      </Typography>
      <UploadStoredEntity
        className={styles.uploadArea}
        accept={manifest.entityTypeMimeExtensions.image}
        parentId={folder.id}
        contentHint="image"
        tags={[SystemTags.HeaderImage]}
        onUploading={handleUploading}
        onUploaded={handleUploaded}
      />
      <Typography variant="subtitle1" className={styles.sectionTitleLarge}>
        Bookmarks
      </Typography>
      <BookmarksButton parent={folder} />
    </>
  )
}
export default FolderControls
